import * as Yup from "yup";

export const AssociateValidationSchema = Yup.object().shape({
  district_id: Yup.string().required("Field is required"),
});

export const AddAssociateInitialValues = {
  district_id: "",
};
